import { TranslationKeys } from './TranslationKeys.js';

var BetErrorMessages = {
    Success: TranslationKeys.YourBetIsAccepted,
    GeneralError: TranslationKeys.BetCanceled,
    InValidMinBet: TranslationKeys.MinimumBet,
    InValidMaxBet: TranslationKeys.MaximumBet,
    InValidMinBetWithValue: TranslationKeys.MinBet,
    InValidMaxBetWithValue: TranslationKeys.MaxBet,
    InvalidBet: TranslationKeys.BetCanceled,
    InsufficientFunds: TranslationKeys.InsufficientFunds,
    MoneyTransactionError: TranslationKeys.BetCanceled,
    UnAuthorizedUser: TranslationKeys.BetCanceled,
    InvalidRoundId: TranslationKeys.WaitForNextRound,
    InvalidBetTime: TranslationKeys.WaitForNextRound,
    InValidBetData: TranslationKeys.BetCanceled,
    FreeBetError: TranslationKeys.BetCanceled,
    ResultNotFound: TranslationKeys.BetCanceled,
    BetsCountExceeded: TranslationKeys.BetCanceled,
    InvalidFreeBetData: TranslationKeys.BetCanceled,
    InvalidFreeBetMaxOdd: TranslationKeys.BetCanceled,
    InvalidFreeBetMinOdd: TranslationKeys.BetCanceled,
    LimitsNotFound: TranslationKeys.BetCanceled,
    PartnerGameConfigNotFound: TranslationKeys.BetCanceled,
    PlayerLimitExceeded: TranslationKeys.PlayerLimitExceeded,
    NotEnoughFreeBets: TranslationKeys.NotEnoughFreeBets,
    PartnerIsUnavailable: TranslationKeys.SomethingWentWrong1,
    // below are custom response codes for games
    InValidAutoCashOutOdd: TranslationKeys.AutoCashOut,
    InValidMaxAutoCashOutOdd: TranslationKeys.AutoCashOut,
    InValidMarket: TranslationKeys.PleaseSelectMarket,
    MaxWinLimitNote: TranslationKeys.MaxWinLimitNote,
    UnderMaintenanceNote: TranslationKeys.UnderMaintenanceInGame,
    YourSeedHasBeenSaved: TranslationKeys.YourSeedHasBeenSaved,
    SlowConnection: TranslationKeys.SlowConnection,
    DoChipWarning: TranslationKeys.DoChipWarning,
    MaxTicket: TranslationKeys.MaxTicket,
    MaxWinNote: TranslationKeys.MaxWinNote,
    FreeBetMaxWinPayout: TranslationKeys.FreeBetMaxWinPayout,
};
var notificationByResponseCode = {
    Success: 'accept',
    GeneralError: 'error',
    InValidMinBet: 'error',
    InValidMaxBet: 'error',
    InValidMinBetWithValue: 'error',
    InValidMaxBetWithValue: 'error',
    InvalidBet: 'error',
    InsufficientFunds: 'error',
    MoneyTransactionError: 'error',
    UnAuthorizedUser: 'error',
    InvalidRoundId: 'warning',
    InvalidBetTime: 'warning',
    InValidBetData: 'error',
    FreeBetError: 'error',
    ResultNotFound: 'error',
    BetsCountExceeded: 'error',
    InvalidFreeBetData: 'error',
    InvalidFreeBetMaxOdd: 'error',
    InvalidFreeBetMinOdd: 'error',
    LimitsNotFound: 'error',
    PartnerGameConfigNotFound: 'error',
    PlayerLimitExceeded: 'error',
    NotEnoughFreeBets: 'warning',
    PartnerIsUnavailable: 'error',
    // below are custom response codes for games
    MaxWinNote: 'warning',
    FreeBetMaxWinPayout: 'warning',
    InValidAutoCashOutOdd: 'error',
    InValidMarket: 'error',
    MaxWinLimitNote: 'error',
    UnderMaintenanceNote: 'error',
    MaintenanceTable: 'maintenance',
    YourSeedHasBeenSaved: 'accept',
    SlowConnection: 'error',
    DoChipWarning: 'warning',
    MaxTicket: 'warning',
    InValidMaxAutoCashOutOdd: 'error',
};
var BetResponseCode;
(function (BetResponseCode) {
    BetResponseCode[BetResponseCode["Success"] = 0] = "Success";
    BetResponseCode[BetResponseCode["GeneralError"] = 1] = "GeneralError";
    BetResponseCode[BetResponseCode["InValidMinBet"] = 2] = "InValidMinBet";
    BetResponseCode[BetResponseCode["InValidMaxBet"] = 3] = "InValidMaxBet";
    BetResponseCode[BetResponseCode["InvalidBet"] = 4] = "InvalidBet";
    BetResponseCode[BetResponseCode["InsufficientFunds"] = 5] = "InsufficientFunds";
    BetResponseCode[BetResponseCode["MoneyTransactionError"] = 6] = "MoneyTransactionError";
    BetResponseCode[BetResponseCode["UnAuthorizedUser"] = 7] = "UnAuthorizedUser";
    BetResponseCode[BetResponseCode["InvalidBetTime"] = 8] = "InvalidBetTime";
    BetResponseCode[BetResponseCode["InvalidRoundId"] = 9] = "InvalidRoundId";
    BetResponseCode[BetResponseCode["InValidBetData"] = 10] = "InValidBetData";
    BetResponseCode[BetResponseCode["InValidToken"] = 11] = "InValidToken";
    BetResponseCode[BetResponseCode["FreeBetError"] = 12] = "FreeBetError";
    BetResponseCode[BetResponseCode["ResultNotFound"] = 13] = "ResultNotFound";
    BetResponseCode[BetResponseCode["BetsCountExceeded"] = 14] = "BetsCountExceeded";
    BetResponseCode[BetResponseCode["InvalidFreeBetData"] = 15] = "InvalidFreeBetData";
    BetResponseCode[BetResponseCode["InvalidFreeBetMaxOdd"] = 16] = "InvalidFreeBetMaxOdd";
    BetResponseCode[BetResponseCode["InvalidFreeBetMinOdd"] = 17] = "InvalidFreeBetMinOdd";
    BetResponseCode[BetResponseCode["LimitsNotFound"] = 18] = "LimitsNotFound";
    BetResponseCode[BetResponseCode["PartnerGameConfigNotFound"] = 19] = "PartnerGameConfigNotFound";
    BetResponseCode[BetResponseCode["PlayerLimitExceeded"] = 20] = "PlayerLimitExceeded";
    BetResponseCode[BetResponseCode["NotEnoughFreeBets"] = 21] = "NotEnoughFreeBets";
    BetResponseCode[BetResponseCode["PartnerIsUnavailable"] = 22] = "PartnerIsUnavailable";
    // below are custom response codes for games
    BetResponseCode[BetResponseCode["InValidAutoCashOutOdd"] = 1000] = "InValidAutoCashOutOdd";
    BetResponseCode[BetResponseCode["InValidMarket"] = 1001] = "InValidMarket";
    BetResponseCode[BetResponseCode["MaxWinLimitNote"] = 1002] = "MaxWinLimitNote";
    BetResponseCode[BetResponseCode["UnderMaintenanceNote"] = 1003] = "UnderMaintenanceNote";
    BetResponseCode[BetResponseCode["YourSeedHasBeenSaved"] = 1004] = "YourSeedHasBeenSaved";
    BetResponseCode[BetResponseCode["SlowConnection"] = 1005] = "SlowConnection";
    BetResponseCode[BetResponseCode["DoChipWarning"] = 1006] = "DoChipWarning";
    BetResponseCode[BetResponseCode["MaxTicket"] = 1007] = "MaxTicket";
    BetResponseCode[BetResponseCode["InValidMaxAutoCashOutOdd"] = 1008] = "InValidMaxAutoCashOutOdd";
    BetResponseCode[BetResponseCode["MaxWinNote"] = 1009] = "MaxWinNote";
    BetResponseCode[BetResponseCode["FreeBetMaxWinPayout"] = 1010] = "FreeBetMaxWinPayout";
    // for platform integration
    BetResponseCode[BetResponseCode["ConnectionError"] = 1011] = "ConnectionError";
    BetResponseCode[BetResponseCode["Reconnect"] = 1012] = "Reconnect";
    BetResponseCode[BetResponseCode["GameIsOpen"] = 1013] = "GameIsOpen";
    BetResponseCode[BetResponseCode["InValidMinBetWithValue"] = 1014] = "InValidMinBetWithValue";
    BetResponseCode[BetResponseCode["InValidMaxBetWithValue"] = 1015] = "InValidMaxBetWithValue";
})(BetResponseCode || (BetResponseCode = {}));
//todo add response codes when check with platform
var BetResponseCodeForHideNotification = [
    BetResponseCode.GeneralError,
    BetResponseCode.InValidMinBet,
    BetResponseCode.InValidMaxBet,
    BetResponseCode.InvalidBet,
    BetResponseCode.MoneyTransactionError,
    BetResponseCode.UnAuthorizedUser,
    BetResponseCode.InvalidBetTime,
    BetResponseCode.FreeBetError,
    BetResponseCode.ResultNotFound,
    BetResponseCode.BetsCountExceeded,
    BetResponseCode.InvalidFreeBetData,
    BetResponseCode.InvalidFreeBetMaxOdd,
    BetResponseCode.InvalidFreeBetMinOdd,
    BetResponseCode.LimitsNotFound,
    BetResponseCode.PartnerGameConfigNotFound,
    BetResponseCode.PlayerLimitExceeded,
    BetResponseCode.NotEnoughFreeBets,
    BetResponseCode.PartnerIsUnavailable,
];
var responseType = {
    Success: 'Success',
    GeneralError: 'GeneralError',
    InValidMinBet: 'InValidMinBet',
    InValidMaxBet: 'InValidMaxBet',
    InValidMinBetWithValue: 'InValidMinBetWithValue',
    InValidMaxBetWithValue: 'InValidMaxBetWithValue',
    InvalidBet: 'InvalidBet',
    InsufficientFunds: 'InsufficientFunds',
    MoneyTransactionError: 'MoneyTransactionError',
    UnAuthorizedUser: 'UnAuthorizedUser',
    InvalidBetTime: 'InvalidBetTime',
    InvalidRoundId: 'InvalidRoundId',
    InValidBetData: 'InValidBetData',
    InValidToken: 'InValidToken',
    FreeBetError: 'FreeBetError',
    ResultNotFound: 'ResultNotFound',
    BetsCountExceeded: 'BetsCountExceeded',
    InvalidFreeBetData: 'InvalidFreeBetData',
    InvalidFreeBetMaxOdd: 'InvalidFreeBetMaxOdd',
    InvalidFreeBetMinOdd: 'InvalidFreeBetMinOdd',
    LimitsNotFound: 'LimitsNotFound',
    PartnerGameConfigNotFound: 'PartnerGameConfigNotFound',
    PlayerLimitExceeded: 'PlayerLimitExceeded',
    NotEnoughFreeBets: 'NotEnoughFreeBets',
    PartnerIsUnavailable: 'PartnerIsUnavailable',
    // below are custom response codes for games
    InValidAutoCashOutOdd: 'InValidAutoCashOutOdd',
    InValidMarket: 'InValidMarket',
    MaxWinLimitNote: 'MaxWinLimitNote',
    UnderMaintenance: 'UnderMaintenance',
    YourSeedHasBeenSaved: 'YourSeedHasBeenSaved',
    SlowConnection: 'SlowConnection',
    DoChipWarning: 'DoChipWarning',
    InValidMaxAutoCashOutOdd: 'InValidMaxAutoCashOutOdd',
    MaxWinNote: 'MaxWinNote',
    FreeBetMaxWinPayout: 'FreeBetMaxWinPayout',
};
Object.freeze(BetErrorMessages);
Object.freeze(notificationByResponseCode);
Object.freeze(responseType);

export { BetErrorMessages, BetResponseCode, BetResponseCodeForHideNotification, notificationByResponseCode, responseType };
